import React from "react";
import {
  CheckboxContainer,
  CheckboxLabel,
  CheckboxOptionContainer,
  CheckboxTitle,
  CheckMark,
  CustomCheckbox,
  HiddenCheckbox,
} from "./checkbox.styled";

interface CheckboxProps {
  title?: string;
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  name: string;
  disabled?: boolean;
  required?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  return (
    <CheckboxContainer className="checkbox-component">
      {props.title && (
        <CheckboxTitle required={props.required}>{props.title}</CheckboxTitle>
      )}

      <CheckboxOptionContainer>
        <HiddenCheckbox
          type="checkbox"
          id={`${props.name}-checkbox`}
          name={props.name}
          checked={props.checked}
          onChange={(e) => props.onChange(e.target.checked)}
          disabled={props.disabled}
        />

        <CustomCheckbox
          htmlFor={`${props.name}-checkbox`}
          disabled={props.disabled}
          checked={props.checked}
        >
          <CheckMark checked={props.checked}>✓</CheckMark>
        </CustomCheckbox>

        <CheckboxLabel htmlFor={`${props.name}-checkbox`} disabled={props.disabled}>
          {props.label}
        </CheckboxLabel>
      </CheckboxOptionContainer>
    </CheckboxContainer>
  );
};
